import { Params } from "./types";
import { getUrlParams } from "./urlParams";

declare global {
    interface Window {
        gtag: any;
        dataLayer: any
    }
}

const gtag: Gtag.Gtag = function () { window.dataLayer.push(arguments); };

export function sendTrackingEvent(action: string) {
    getUrlParams().then((urlParams: Params) => {
        let eventStr = action + ' ' + urlParams.paramStr;
        console.log('event:', eventStr);
        gtag("event", eventStr);
    })
}